import React from 'react';

export function Input({ label, value, onChange, placeholder = '', type = 'text', icon = null, error = '', helper = '', required = false, disabled = false, style = {}, ...rest }) {
  const [focus, setFocus] = React.useState(false);
  const borderColor = error ? 'var(--danger)' : focus ? 'var(--accent)' : 'var(--border-strong)';
  return (
    <label style={{ display: 'block', ...style }}>
      {label && (
        <span style={{ display: 'block', marginBottom: 'var(--space-2)', fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-sm)', fontWeight: 'var(--fw-semibold)', color: 'var(--text-strong)' }}>
          {label}{required && <span style={{ color: 'var(--danger)' }}> *</span>}
        </span>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.6em', height: 'var(--control-h-md)', padding: '0 14px', background: disabled ? 'var(--surface-sunken)' : 'var(--surface-card)', border: `1.5px solid ${borderColor}`, borderRadius: 'var(--radius-md)', boxShadow: focus ? '0 0 0 4px var(--ring)' : 'none', transition: 'border-color var(--dur-fast), box-shadow var(--dur-fast)' }}>
        {icon && <span style={{ color: focus ? 'var(--accent)' : 'var(--text-muted)', display: 'flex' }}>{icon}</span>}
        <input type={type} value={value} onChange={onChange} placeholder={placeholder} disabled={disabled} required={required}
          onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}
          style={{ flex: 1, border: 'none', outline: 'none', background: 'transparent', fontFamily: 'var(--font-body)', fontSize: 'var(--fs-body)', color: 'var(--text-strong)', minWidth: 0 }}
          {...rest} />
      </div>
      {(error || helper) && (
        <span style={{ display: 'block', marginTop: 'var(--space-2)', fontFamily: 'var(--font-ui)', fontSize: 'var(--fs-xs)', color: error ? 'var(--danger)' : 'var(--text-muted)' }}>
          {error || helper}
        </span>
      )}
    </label>
  );
}
